export default __webpack_public_path__ + "static/img-projects-01-4a865af388bd923e4237e70543d6b0d6.png";